import Alpine from "alpinejs";
import { embedYtScript } from "../../helpers/youtube.js";
import { damPlayer } from "../../helpers/dam.js";

Alpine.magic("embedYtScript", () => (player, config = { autoplay: false }) => {
    return embedYtScript(player, config);
});

Alpine.magic("damPlayer", () => (video) => {
    return damPlayer(video);
});